export enum EventView {
    info = 0,
    register = 1
  }